import { IdentificationModal } from '@fiverr-private/identification_marketplace';

export default IdentificationModal;
